/**
 * Kleine Darstellungshelfer, die mehrere Ansichten teilen.
 *
 * `noteDate` stand frueher in views/notes.ts. Mit dem Wegfall des
 * Notizen-Reiters wurde daraus eine heimatlose Funktion, die trotzdem noch
 * an mehreren Stellen gebraucht wird – deshalb liegt sie jetzt hier und
 * nicht in einer Ansicht, die es nicht mehr gibt.
 */

/** "14:32" fuer heute, "Gestern", sonst ein Datum. */
export function noteDate(timestamp: number): string {
  const date = new Date(timestamp);
  const today = new Date();
  if (date.toDateString() === today.toDateString()) {
    return date.toLocaleTimeString('de', { hour: '2-digit', minute: '2-digit' });
  }
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return 'Gestern';
  return date.toLocaleDateString('de', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
